import { render, staticRenderFns } from "./LineChart2.vue?vue&type=template&id=4fb06ce0&scoped=true"
import script from "./LineChart2.vue?vue&type=script&lang=js"
export * from "./LineChart2.vue?vue&type=script&lang=js"
import style0 from "./LineChart2.vue?vue&type=style&index=0&id=4fb06ce0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb06ce0",
  null
  
)

export default component.exports